<template>
    <div class="ds-card ds-stat-card">
        <div class="ds-stat-card__top">
            <div class="ds-icon-tile" :style="{ background: toneColor }">
                <ds-icon :name="icon" :size="34" />
            </div>
            <div class="ds-stat-card__value-wrap">
                <div class="ds-stat-card__label">{{ label }}</div>
                <div class="ds-stat-card__value">{{ value }}</div>
            </div>
        </div>
        <div class="ds-stat-card__bottom">
            <div class="ds-card-divider"></div>
            <div class="ds-card-footer">
                <span><slot name="caption"></slot></span>
            </div>
        </div>
    </div>
</template>

<script>
const TONES = {
    100: 'var(--blue-100)',
    500: 'var(--blue-500)',
    700: 'var(--blue-700)',
    900: 'var(--blue-900)',
}
export default {
    name: 'DsStatCard',
    props: {
        icon: { type: String, required: true },
        tone: { type: [Number, String], default: 500 },
        label: { type: String, default: '' },
        value: { type: [String, Number], default: '' },
    },
    computed: {
        toneColor() {
            return TONES[this.tone] || this.tone
        },
    },
}
</script>

<style scoped>
.ds-card {
    background: var(--surface-card);
    border: var(--border-width) solid var(--border-card);
    border-radius: var(--radius-md);
    box-shadow: var(--shadow-card);
}
.ds-stat-card { position: relative; padding: 0; height: 100%; box-sizing: border-box; }
.ds-stat-card__top {
    display: flex;
    align-items: flex-start;
    gap: var(--space-4);
    padding: var(--space-5);
    padding-bottom: var(--space-4);
}
.ds-icon-tile {
    width: var(--icon-tile-size);
    height: var(--icon-tile-size);
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: var(--radius-md);
    color: var(--text-on-accent);
    box-shadow: var(--shadow-tile);
    flex: 0 0 auto;
    margin-top: var(--icon-tile-offset);
    margin-left: var(--space-1);
}
.ds-stat-card__value-wrap { margin-left: auto; text-align: right; min-width: 0; }
.ds-stat-card__label { font: var(--type-label); color: var(--text-muted); }
.ds-stat-card__value { font: var(--type-card-value); color: var(--text-heading); margin-top: var(--space-1); }
.ds-stat-card__bottom { padding: 0 var(--space-5) var(--space-4); }
.ds-card-divider { height: 1px; background: var(--border-divider); }
.ds-card-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: var(--space-3);
    padding-top: var(--space-3);
    font: var(--type-label);
    color: var(--text-muted);
    flex-wrap: wrap;
}
</style>
